import React, {FC} from "react"
import {withTheme, DefaultTheme} from "styled-components"

import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"

import {H3, Label} from "@irati/ui/src/Typography"

import {BoosterSavingsBg} from "./styled"

interface Props {
  value?: string
  theme: DefaultTheme
  isCurrencySaving?: boolean
  currency?: string
}

const BoostedAmount: FC<Props> = ({value, theme, isCurrencySaving, currency}) => {
  if (!value) {
    return null
  }

  const displayedValue = isCurrencySaving ? <FormattedCurrency value={value} currency={currency} isCents={false} /> : `${value}%`

  return (
    <BoosterSavingsBg direction="column" padding={1}>
      <Label small color={`${theme.colors.primary2}`} textAlign="center">
        <FormattedMessage id="perks.deals.boostedSaving.boostedAmount.text" />
      </Label>
      <H3 color={`${theme.colors.primary2}`} textAlign="center">
        {displayedValue}
      </H3>
    </BoosterSavingsBg>
  )
}

export default withTheme(BoostedAmount)
